import { FirebaseDocument } from "common/models/FirebaseDocument";
import {
  createModelMapModelFromDocument,
  createNewModeMap,
  ModelMap,
} from "modules/modelMap/models/ModelMap";
import { ModelMapStore } from "modules/modelMap/ModelMapStore";
import { firestore } from "common/Firebase";
import { WBSStore } from "modules/WBS/WBSStore";
import { DevelopmentStore } from "modules/development/DevelopmentStore";
import { ProfileService } from "modules/profile/ProfileService";
import { TakeOffStore } from "modules/takeOff/TakeOffStore";
import { LoginStore } from "modules/login/LoginStore";
import { deleteField, now } from "utils/FirebaseUtils";
import * as _ from "lodash";
import { EModelMapType } from "common/enums";
import { TQuerySnapshot } from "common/types/FirebaseTypes";

/**
 * Service de Model-Maps
 * @category Model-Maps
 * @hideconstructor
 */

class ModelMapService {
  /**
   * Adiciona um Snasphot na coleção de Model-Maps e executando a
   * função de callback a cada alteração disparada.
   */
  fetchModelMapsFromDataBase(
    developmentId: string,
    callback: (snapshot: TQuerySnapshot) => void
  ): void {
    try {
      LoginStore.clearModelMapsSnapshot();
      LoginStore.modelMapsSnapshot = firestore
        .collection("modelMaps")
        .where("developmentId", "==", developmentId)
        .onSnapshot(callback);
    } catch (e) {
      console.log(e);
    }
  }

  async deleteModelMapFromDataBase(model): Promise<void> {
    try {
      await firestore.collection("modelMaps").doc(model.id).delete();
    } catch (e) {
      console.log("Delete model map error: ", e);
      console.log(e);
    }
  }

  /**
   * Atualiza a propriedade labels de um objeto Model Map com a identificação dos elementos utilizados na formatação
   * @param modelMap Model Map para atualizar
   */
  async updateModelMapIfcGUIDs(modelMap): Promise<void> {
    let GUID: { [k: string]: any } = {};
    // If/else para adicionar as informações dos elementos que foram utilizados no cálculo da quantidade da formatação
    for (let i = 0; i < TakeOffStore.takeOffFilteredItems.length; i++) {
      let item = TakeOffStore.takeOffFilteredItems[i];
      if (GUID.hasOwnProperty(item.file.id)) {
        GUID[item.file.id].push(item.GUID);
      } else {
        GUID[item.file.id] = new Array();
        GUID[item.file.id].push(item.GUID);
      }
    }

    if (TakeOffStore.takeOffModelMap !== undefined) {
      TakeOffStore.takeOffModelMap.data.GUID = GUID;
    }

    return;
  }

  async moveTakeOffFormattedItemsToDeveloment() {
    const wbsRef = firestore
      .collection("wbsProjectBudget")
      .doc(WBSStore.currentWbsId);
    const wbsData = await wbsRef.collection("takeOffFormatedItems").get();
    for (let i of wbsData.docs) {
      await firestore
        .collection("developments")
        .doc(DevelopmentStore.developmentId)
        .collection("takeOffFormatedItems")
        .add(i.data());
    }
  }

  async verifyCurrentWbsNeedToUpdatedAtAllModelMaps() {
    ModelMapStore.setIsCurrentWbsNeedToBeUpdated();
    for (const modelMap of ModelMapStore.modelMaps) {
      await this.fetchModelMapsWbsNeedToUpdated(modelMap.id);
    }
  }

  async fetchModelMapsWbsNeedToUpdated(ModelMapId) {
    const modelMapDoc = firestore.collection("modelMaps").doc(ModelMapId);
    const modelMapData = await modelMapDoc.get().then((doc) => doc.data());

    if (modelMapData) {
      const costPlans = modelMapData.costPlansNeedtoBeUpdated;
      if (costPlans !== undefined) {
        if (costPlans.includes(WBSStore.currentWbsId)) {
          ModelMapStore.setIsCurrentWbsNeedToBeUpdated();
          return true;
        }
      } else {
        await modelMapDoc.update({
          costPlansNeedtoBeUpdated: [],
        });
        if (ModelMapStore.oldProjectUpdated == false) {
          ModelMapStore.isOldProjectUpdated(true);
          await this.moveTakeOffFormattedItemsToDeveloment();
        }
      }
    }
    return false;
  }

  hasCurrentWbsNeedToUpdatedModelMap(ModelMapId): boolean {
    const modelMapData = ModelMapStore.modelMapsView.find(
      (mm) => mm.id === ModelMapId
    );
    if (modelMapData && modelMapData.data) {
      const costPlans = modelMapData.data.costPlansNeedtoBeUpdated || [];
      return costPlans.includes(WBSStore.currentWbsId);
    }
    return false;
  }

  //metodo chamado quando o usuario atualiza as informações da EAP
  async removeCurrentWbsCostPlansNeedtoBeUpdated(ModelMapId) {
    let costPlansNeedtoBeUpdated: any = [];
    try {
      let modelMapFirestore = await firestore
        .collection("modelMaps")
        .doc(ModelMapId)
        .get();
      let modelMapData = modelMapFirestore.data();
      if (modelMapData) {
        for (let i = 0; i < modelMapData.costPlansNeedtoBeUpdated.length; i++) {
          if (
            modelMapData.costPlansNeedtoBeUpdated[i] != WBSStore.currentWbsId
          ) {
            costPlansNeedtoBeUpdated.push(
              modelMapData.costPlansNeedtoBeUpdated[i]
            );
          }
        }
        await firestore.collection("modelMaps").doc(ModelMapId).update({
          costPlansNeedtoBeUpdated: costPlansNeedtoBeUpdated,
        });
        for (let i = 0; i < ModelMapStore.modelMapsView.length; i++) {
          if (ModelMapStore.modelMapsView[i].id == ModelMapId) {
            ModelMapStore.modelMapsView[i].data.costPlansNeedtoBeUpdated =
              costPlansNeedtoBeUpdated;
          }
        }
        ModelMapStore.setIsCurrentWbsNeedToBeUpdated();
      }
    } catch (e) {
      console.log("Error: ", e);
    }
  }

  //metodo que adiciona os planos que devem ser atualizados quando o model map é alterado
  async wbsThatNeedToBeUpdated(model) {
    let costPlans: any = [];
    let costPlansNeedtoBeUpdated: any = [];
    let costPlan: any;
    let costPlanNeedtoBeUpdated: any;
    try {
      let modelMapFirestore = await firestore
        .collection("modelMaps")
        .doc(model.id)
        .get();
      let modelMapData = modelMapFirestore.data();
      if (modelMapData) {
        costPlans = modelMapData.costPlans;
        for (let i = 0; i < modelMapData.costPlans.length; i++) {
          costPlan = modelMapData.costPlans[i];
          costPlanNeedtoBeUpdated = modelMapData.costPlansNeedtoBeUpdated[i];
          if (costPlan != costPlanNeedtoBeUpdated) {
            costPlansNeedtoBeUpdated.push(costPlan);
          }
        }

        model.data.costPlans = costPlans;
        model.data.costPlansNeedtoBeUpdated = costPlansNeedtoBeUpdated;

        return model;
      }
    } catch (e) {
      console.log(e);
    }
  }

  async changeModelMapName(model, name) {
    await firestore.collection("modelMaps").doc(model.id).update({ name });
  }

  async fetchTypesOrMaterialsFromDataBase(
    developmentId: string,
    searchInCollection: string,
    fileId: string
  ) {
    let selectionArray = new Array();
    let propertiesArray = new Array();

    await firestore
      .collection("developments")
      .doc(developmentId)
      .collection(searchInCollection)
      .where("file.id", "==", fileId)
      .get()
      .then(function (snapshot) {
        snapshot.forEach(function (doc) {
          let docData = doc.data();
          const isTypes = docData.types !== undefined;
          const result = isTypes
            ? _.keys(docData.types)
            : _.keys(docData.materials);

          result.forEach((key) => {
            if (selectionArray.indexOf(key) === -1) selectionArray.push(key);
          });

          propertiesArray = isTypes ? docData.types : docData.materials;
        });
      })
      .catch(function (error) {
        console.log("Error getting documents: ", error);
      });

    return [selectionArray, propertiesArray];
  }

  async createModelMapOnDataBase(
    developmentId: string,
    name: string,
    type: EModelMapType,
    types: string[],
    ifcs: string[],
    useAllModels: boolean
  ): Promise<FirebaseDocument<ModelMap> | undefined> {
    try {
      // Nao mexi aqui pq não sei se ainda possui uso
      if (ifcs.length == 0) {
        for (const file of ModelMapStore.lastFileSelection) {
          ifcs.push(file.replace("sw_", ""));
        }
      }

      const modelMap = createNewModeMap(
        name,
        developmentId,
        ifcs,
        useAllModels,
        type,
        types,
        { [ProfileService.getUserId()]: 0 }
      );

      try {
        const model = await firestore
          .collection("modelMaps")
          .add({ ...modelMap })
          .then(
            async (doc) => new FirebaseDocument<ModelMap>(doc.id, modelMap)
          );
        return model;
      } catch (e) {
        console.log("Error to add ModelMap: ", e);
      }
    } catch (e) {
      console.log("Error to add ModelMap: ", e);
      console.log(e);
    }
    return;
  }

  async updateModelMapOnDataBase(
    model: FirebaseDocument<ModelMap>,
    format: boolean
  ): Promise<void> {
    try {
      const modelMapId = model.id;
      const { useAllModels, categoryErrors, modelErrors, formatErrors } =
        model.data;
      const newData = {
        ...model.data,
        useAllModels: useAllModels != undefined ? useAllModels : true,
        categoryErrors: categoryErrors ? categoryErrors : [],
        modelErrors: modelErrors ? modelErrors : [],
        formatErrors: formatErrors ? formatErrors : [],
        modifiedAt: now(),
      };

      if (format) newData.status = "pending";
      await firestore.collection("modelMaps").doc(modelMapId).set(newData);

      // Adiciona observador para verificar o processo de aplicar formatação
      if (format) {
        TakeOffStore.setTakeOffSaveformate(true);
        let observer = await firestore
          .collection("modelMaps")
          .doc(modelMapId)
          .onSnapshot((snapshot) => {
            const data = snapshot.data();
            if (!data || data.status !== "pending") {
              TakeOffStore.verifyItensAndSetTakeOffFormated(modelMapId);
              if (observer) observer();
            }
          });
      }
    } catch (e) {
      console.log("Update model map error: ", e);
      console.log(e);
    }
  }

  async getModelMap(
    modelMapID: string
  ): Promise<FirebaseDocument<ModelMap> | undefined> {
    let doc = await firestore.collection("modelMaps").doc(modelMapID).get();
    let modelMapData = createModelMapModelFromDocument(doc);
    return modelMapData;
  }

  async updateModelMapCostPlansNeedtoBeUpdated(
    modelMapId: string,
    costPlansNeedtoBeUpdated: string[] = []
  ): Promise<void> {
    return firestore
      .collection("modelMaps")
      .doc(modelMapId)
      .update({ costPlansNeedtoBeUpdated });
  }
}

const service = new ModelMapService();
export { service as ModelMapService };



// WEBPACK FOOTER //
// ./src/modules/modelMap/ModelMapService.ts